define('views/shared/tab/tab_component',[
    'backbone',
    'views/_base/baseview',
    'text!views/shared/tab/tab_component.html',
    'views/shared/tab/tab_panel'
], function(Backbone, BaseView, Template, TabPanelComponent){
    'use strict';

    return BaseView.extend({
        className: 'tab-component-container',
        tagName  : 'div',
        isRender : true,
        template : _.template(Template),
        events   : {},

        initialize: function(options){
            options = options || {};

            this.context = options.context;

            this.tabs = options.tabs;
            this.tab_panels = options.tab_panels;
            
            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            this.createTabs();

            this.createTabPanels();

            return this;
        },

        createTabs: function(){
            var that = this;

            this.tabs.forEach(function(tab, index){

                var class_html = 'tab-btn',
                    panel_id_html = ((tab.panel_id) ? ' data-btn-panel-id="' + tab.panel_id + '"' : '');
                
                if(index == 0){
                    class_html += ' active';
                }

                var tab_html = '<li><a href="#" class="' + class_html + '"' + panel_id_html + '>' + tab.name + '</a></li>';

                that.$el.find('.js-tabs').append(tab_html);

            });

            this.$el.find('.tab-btn').on('click', function(e){
                if(e && e.preventDefault){ e.preventDefault(); }
                if(e && e.stopPropagation){ e.stopPropagation(); }

                that.handleTabClick(e);
            });

        },

        createTabPanels: function(){
            var that = this;

            if(this.tab_panels){

                this.tab_panels.forEach(function(panel, index){

                    var panel_view = new TabPanelComponent({ panel_content: panel, context: that.context });

                    // Add the panel_view to the tab_panel for later use
                    that.tab_panels[index].panel_view = panel_view;

                    if(index == 0){
                        // panel_view.$el.addClass('active');
                        panel_view.showPanel();
                    }

                    that.$('.js-tab-content').append(panel_view.el);

                });

            }

        },

        handleTabClick: function(e){

            var that = this,
                panel_id = $(e.target).data('btn-panel-id');

            if(panel_id){

                // Add and remove the active class from tab buttons
                this.$el.find('.js-tabs').find('.tab-btn').each(function(index, tab){

                    if($(tab).data('btn-panel-id') == panel_id){
                        $(tab).addClass('active');
                    } else if($(tab).hasClass('active')){
                        $(tab).removeClass('active');
                    }

                });

                // Show and hide the appropriate panel
                this.tab_panels.forEach(function(panel, index){

                    if(panel.panel_id == panel_id){
                        panel.panel_view.showPanel();
                    } else {
                        panel.panel_view.hidePanel();
                    }

                });

            }

        },

        reloadPanel: function(panel_id, content){
            var that = this;

            if(this.tab_panels){

                this.tab_panels.forEach(function(panel, index){

                    if(panel.panel_id == panel_id){
                        panel.panel_view.reloadPanel(content);
                    }

                });

            }

        },

        close: function(){}
    });
});

